import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';

import { devices } from 'styles';

export const ImageWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  display: block;
  border-radius: 8px;

  img {
    width: 100%;
    height: 300px;
    display: block;
    border-radius: 16px;
    object-fit: cover;

    @media (${devices.sm}) {
      width: 100%;
      height: 300px;
    }

    @media (${devices.md}) {
      width: 560px;
      height: 640px;
    }
  }

  @media (${devices.sm}) {
    margin-top: 0;
  }
`;
